export enum FORM_MODE {
  create = 'create',
  view = 'view',
  edit = 'edit',
  list = 'list',
  listDetail = 'listDetail',
}

export enum SETTINGS_MODE {
  users = 'users',
  policies = 'policies',
}

export enum CONTAINERS_LIST {
  EPS = 'EPS',
  MAILING = 'MAILING',
  REMUNERATION = 'REMUNERATION',
  FILES = 'FILES',
  CUSTOMERS = 'CUSTOMERS',
  EXEMPTION = 'EXEMPTION',
  PORTFOLIO = 'PORTFOLIO',
  HELP = 'HELP',
  SETTINGS = 'SETTINGS',
  RESULT = 'RESULT',
  NO_CAR_OI_ACCESS = 'NO_CAR_OI_ACCESS',
  QUERY = 'QUERY',
}

export enum REMUNERATION_CONTAINERS_LIST {
  FLOW = 'FLOW',
}

export enum RESULT_CONTAINERS_LIST {
  EPS = 'EPS',
  SERVICE_CATEGORY = 'SERVICE_CATEGORY',
}

export enum MAILING_CONTAINERS_LIST {
  MAILING_RULES = 'MAILING_RULES',
  MAILING_STRATEGIES = 'MAILING_STRATEGIES',
}

export enum STATUS_LABEL {
  active = 'Ativo',
  inactive = 'Inativo',
}

export enum MAILING_RULE_STEPS_IDS {
  NO_STEP = -1,
  GENERAL_RULES_FORM = 0,
  TEMPORAL_PARAMETERS_FORM = 1,
  RULES_EXECUTION_FORM = 2,
  DEBTUP_DATE_FORM = 3,
  EPS_SELECTION_FORM = 4,
  REMUNERATION_FORM = 5,
}

export enum PERIODICITY {
  monthly = 'MONTHLY',
  quarterly = 'QUARTERLY',
  halfYearly = 'HALF_YEARLY',
  monthSpecification = 'MONTH_SPECIFICATION',
}
